// Mock data for Byron Batten Consulting website

export const brand = {
  name: 'BBC',
  full: 'Byron Batten Consultancy',
  tagline: 'Changing perspective. Guiding insights.',
  strap: "It's not how you look but what you see.",
  email: 'byron@byronbattenconsultancy.co.uk',
  phone: '+44 7976 295181',
  location: 'Birmingham, United Kingdom',
  social: [
    { label: 'LinkedIn', href: 'https://www.linkedin.com/in/byronbatten/' },
    { label: 'Instagram', href: 'https://www.instagram.com/' }
  ]
};

export const nav = [
  { label: 'Home', to: '/' },
  { label: 'Who we are', to: '/about' },
  { label: 'What we do', to: '/services' },
  { label: 'Talk to us', to: '/contact' }
];

export const values = [
  {
    key: 'kindness',
    title: 'Kindness',
    body: 'Change asks people to be seen honestly, including where they\u2019re stuck. We hold that with warmth, not judgement, because psychological safety is what makes honest behaviour change possible.'
  },
  {
    key: 'integrity',
    title: 'Integrity',
    body: 'We say what we see, even when it\u2019s uncomfortable. Diagnosis before intervention, evidence before opinion, that\u2019s what makes the insight trustworthy enough to act on.'
  },
  {
    key: 'focus',
    title: 'Focus',
    body: 'Insight can be easy. Follow-through is hard. Our focus stays on the behaviours, systems and accountability that turn a good intention into something that actually sustains.'
  }
];

export const services = [
  {
    id: 'coaching',
    kicker: '01 — Coaching',
    title: 'Knowing isn\u2019t doing.',
    subtitle: 'Coaching for senior leaders.',
    body: 'You already know what good leadership looks like. The challenge is applying it consistently, under pressure, in real situations.\n\nThis is a behavioural approach to coaching, focused on understanding what drives your actions and what gets in the way.',
    bullets: [
      'One-to-one leadership coaching',
      'Assessments: Gallup Strengths, MiRo Psychometric, CQ certification',
      'In-person or online delivery'
    ]
  },
  {
    id: 'consulting',
    kicker: '02 — Consultancy',
    title: 'Facilitation & Development',
    subtitle: 'Programmes, workshops and cultural reviews',
    body: 'Most organisations know what needs to change. The challenge is understanding how it happens.\n\nUsing a behavioural lens, we work with you to understand what\u2019s really needed to drive change and embed culture across your organisation, and how to shift it in practice.',
    bullets: [
      'Leadership development programmes',
      'Bespoke workshops & facilitation',
      'Action learning set facilitation',
      'Cultural reviews and organisational insight',
      'Transformation and change support'
    ]
  },
  {
    id: 'speaking',
    kicker: '03 — Speaking',
    title: 'Speaking & Perspectives',
    subtitle: 'Behaviour, leadership and systems',
    body: 'In a world of endless channels, podcasts, vlogs, panels, keynotes, the value of speaking depends on whether there\u2019s something worth saying.\n\nI speak because the evidence and experience behind this work has something specific to offer leaders navigating culture, inclusion and change.',
    bulletsIntro: 'Some keynote sessions and support offers:',
    bullets: [
      'Mind the intention-behaviour gap',
      'You\u2019re not as rational as you think',
      'Cultural Intelligence (CQ)',
      'Keynotes and panel conversations'
    ]
  }
];

export const engagementGears = [
  { letter: 'D', title: 'Define', body: 'Choose the area or topic to inquire into — getting to the vital point of concern or improvement.' },
  { letter: 'D', title: 'Discover', body: "Identify what works — the strengths, successes and periods of proficiency." },
  { letter: 'D', title: 'Develop', body: 'A programme of possibility that enacts the positive core with you.' },
  { letter: 'D', title: 'Deliver', body: 'New ways of thinking and new actions using varied facilitation tools.' },
  { letter: 'D', title: 'Decide', body: 'Evaluate to ensure the defined goals have been achieved.' }
];

export const clients = [
  'West Midlands Police', 'Local Authorities', 'NHS Trusts', 'Third Sector', 'Private Sector'
];

export const testimonials = [
  {
    quote: 'Byron doesn\u2019t hand you answers; he asks the questions that lead you to find your own, in places you didn\u2019t realise you had them. After 36 years in healthcare, I didn\u2019t expect to be rethinking everything I thought I knew about myself as a professional, but that\u2019s exactly what working with Byron did.',
    who: 'Freedom to Speak Up Guardian, NHS Trust'
  },
  {
    quote: 'Participants left the programme able to connect ideas they\u2019d long held but never joined up, with clearer understanding of how to influence change in their own roles, and the courage to challenge the status quo. Leaders left not just with actions for their organisations, but a clearer sense of who they want to become as inclusive leaders.',
    who: 'Senior Leaders, Local Authorities'
  },
  {
    quote: 'A rare facilitator who brings both rigour and heart to cultural conversations. Byron was a critical friend, unearthing our strengths and successes and providing focus for future growth and development. We saw real shifts across the organisation.',
    who: 'CEO, Community Organisation'
  }
];

export const readingList = [
  'Daring to Lead — Brené Brown',
  'Fierce Leadership — Susan Scott',
  'Native — Akala',
  'The Inside-Out Revolution — Michael Neill',
  'The Coaching Habit — Michael Bungay Stanier',
  'Rebel Ideas — Matthew Syed'
];

export const interests = [
  'Coaching', 'Consultancy', 'Workshops', 'Training', 'Speaking'
];

export const images = {
  hero: 'https://customer-assets-4nw71qhi.emergentagent.net/job_dragon-dev/artifacts/krn2ge05_image-1%20%281%29.jpeg',
  byron: 'https://customer-assets-4nw71qhi.emergentagent.net/job_dragon-dev/artifacts/tr1ggbdv_Byron%2005052026.png',
  coaching: 'https://customer-assets-4nw71qhi.emergentagent.net/job_dragon-dev/artifacts/djtyv59x_DSC_2590.webp',
  speaking: 'https://customer-assets-4nw71qhi.emergentagent.net/job_dragon-dev/artifacts/o5m5j69j_ChatGPT%20Image%20Sep%2020%2C%202026%2C%2012_56_47%20PM.png',
  workshop: 'https://customer-assets-4nw71qhi.emergentagent.net/job_dragon-dev/artifacts/aw4pcs97_ChatGPT%20Image%20Sep%2020%2C%202026%2C%2011_46_08%20AM.png'
};
